import React from 'react';
import { MapPin, Phone, Globe, Tag, ChevronRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

export const ActivityCard = ({ activity, onClick }) => {
  return (
    <Card 
      className="group cursor-pointer hover:shadow-xl transition-all duration-300 overflow-hidden border-gray-200 hover:border-teal-400"
      onClick={() => onClick(activity)}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-gray-100">
        <img
          src={activity.image}
          alt={activity.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {activity.featured && (
          <Badge className="absolute top-3 right-3 bg-green-500 hover:bg-green-600 border-0">
            In Evidenza
          </Badge>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      <CardContent className="p-6">
        {/* Category Badge */}
        <Badge variant="outline" className="mb-3 text-teal-700 border-teal-300">
          {activity.category}
        </Badge>

        {/* Name */}
        <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
          {activity.name}
        </h3>

        {/* Location */}
        <div className="flex items-start text-gray-600 mb-3">
          <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0 text-purple-500" />
          <span className="text-sm">{activity.zone}</span>
        </div>

        {/* Discount */}
        <div className="flex items-center bg-gradient-to-r from-teal-50 to-purple-50 rounded-lg p-3 mb-4">
          <Tag className="w-5 h-5 mr-2 text-teal-600" />
          <span className="text-sm font-semibold text-gray-800">{activity.discount}</span>
        </div>

        {/* Description */}
        <p className="text-sm text-gray-600 mb-4 line-clamp-2">
          {activity.description}
        </p>

        {/* View Details Button */}
        <Button
          variant="ghost"
          className="w-full group-hover:bg-teal-50 group-hover:text-teal-700 transition-colors"
        >
          Visualizza Dettagli
          <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </Button>
      </CardContent>
    </Card>
  );
};